import type {ReactElement} from 'react';
import Menu from '@components/admin/Menu/Menu';
import {Outlet} from 'react-router-dom';
import styles from './adminRoot.module.scss';

export default function AdminRoot(): ReactElement {
    return (
        <div className={styles.root}>
            <Menu />
            <section className={styles.content}>
                <Outlet />
            </section>
        </div>
    );
}
